import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`;

export const SplitContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: row;
    & > *:nth-child(even) {
        display: flex;
        flex: 1;
        margin: 0 0 0 1.75rem;
    }
    & > *:nth-child(odd) {
        display: flex;
        flex: 1;
        margin: 0 1.75rem 0 0;
    }
`;

export const EditButtons = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`;
